import { useSyncExternalStore } from "react"

/**
 * One failure note on the page at a time. A row's download or preview failure
 * is reported here under the row's id; reporting another replaces it, and
 * `clearRowError` removes it. Rows read their own note with `useRowError`.
 *
 * Module state on purpose: the notes belong to rows that never share a parent
 * context, and the rule ("any new download or preview clears the old note")
 * spans all of them.
 */
let current: { owner: string; message: string } | null = null
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

export function reportRowError(owner: string, message: string): void {
  current = { owner, message }
  emit()
}

export function clearRowError(): void {
  if (!current) return
  current = null
  emit()
}

function subscribe(listener: () => void) {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function useRowError(owner: string): string | null {
  return useSyncExternalStore(
    subscribe,
    () => (current?.owner === owner ? current.message : null),
    () => null,
  )
}
